import './PricePod.scss';

import classnames from 'classnames';
import React from 'react';

import {
	currencyFormatter,
	savingsPercentage,
} from '../../../utilities/number-utilities';
import TRANSLATIONS from './translations@default.json';

const formatter = currencyFormatter(TRANSLATIONS.general);

const SaveWasContainer = ({ was, save, displayWasPrice }) => {
	return (
		<div className="flex text-body-xs justify-end">
			<div className="text-tertiary text-right xl:text-left">
				{displayWasPrice ? TRANSLATIONS.price.was : TRANSLATIONS.price.RRP}{' '}
				<span data-testid={displayWasPrice ? 'price-was' : 'price-rrp'}>
					{formatter.format(was)}
				</span>
			</div>
			<div className="font-bold text-deals ml-2 text-right xl:text-left">
				{TRANSLATIONS.price.save}{' '}
				<span data-testid="price-percentage">
					{savingsPercentage(was, save)}
				</span>
			</div>
		</div>
	);
};

const PricePod = ({
	viewModel: {
		NowPrice,
		WasPrice,
		SavePrice,
		RetailPriceIncVat,
		RetailPriceSavings,
	} = {},
}) => {
	if (!NowPrice) {
		return null;
	}

	const dealAvailable = SavePrice > 0 || RetailPriceSavings > 0;

	const displayWasPrice = WasPrice > 0 && SavePrice > 0;

	const was = displayWasPrice ? WasPrice : RetailPriceIncVat;
	const save = displayWasPrice ? SavePrice : RetailPriceSavings;

	return (
		<div className="flex flex-col w-1/2">
			<div className="text-right xl:text-left text-body-xs">
				Price match promise
			</div>
			<div
				className={classnames('text-title-lg flex justify-end', {
					'text-deals': dealAvailable,
				})}
				data-testid="price-now">
				{formatter.format(NowPrice)}
			</div>

			{was > 0 && save > 0 && (
				<SaveWasContainer {...{ was, save, displayWasPrice }} />
			)}
		</div>
	);
};

export default PricePod;
